import { SVGProps } from "react";

const TwitterIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="24" height="24" rx="12" fill="#333333" />
      <path
        d="M5.54741 6L10.561 12.7036L5.51575 18.1539H6.65122L11.0683 13.3821L14.6372 18.1539H18.5013L13.2056 11.0732L17.9017 6H16.7662L12.6983 10.3948L9.41148 6H5.54741ZM7.21721 6.83639H8.99237L16.8312 17.3174H15.056L7.21721 6.83639Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TwitterIcon;
